import {
	CircularProgress,
	FormControl,
	FormHelperText,
	TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import { ErrorModal } from "../../components/modals/error-modal";
import { useSearchAssets } from "../../configuration/pages/asset/hooks/useSearchAssets";
import { AssetCode } from "../../configuration/pages/asset/models/AssetCode";
import { Asset } from "../../models/Asset";
import { TreePickerControlV2 } from "../filters/TreePickerControlV2";
import { TreeNode } from "../filters/dialogFilter";

const buildTreeAssets = (nodes: AssetCode[]): TreeNode => {
	//tree build functions
	const idMapping = nodes.reduce((acc: any, el: AssetCode, i: number) => {
		// console.log(acc)
		acc[el.id] = i;
		return acc;
	}, {});
	let root;
	nodes.forEach((el: AssetCode) => {
		// Handle the root element
		if (el.parentId === null) {
			root = el;
			return;
		}
		// Use our mapping to locate the parent element in our data array
		const parentEl = nodes[idMapping[el.parentId]];
		// Add our current el to its parent's `children` array
		if (parentEl) {
			parentEl.children = [...(parentEl?.children || []), el];
		}
	});
	// @ts-ignore
	return root;
};

export const AssetTreePicker = ({
	label = "Asset",
	value,
	onChange,
	disabled,
	fieldError,
	filterAssets = false,
}: {
	label?: String;
	value: number | null;
	onChange: (value: number | null) => void;
	disabled?: boolean;
	fieldError?: FieldError | undefined;
	filterAssets?: boolean;
}) => {
	const [error, setError] = useState("");

	const { data, isLoading, error: e, isError } = useSearchAssets();

	const rowsMapped = (Array.isArray(data) ? data : [])
		.filter((a) => !filterAssets || a.CanBeDefaultAsset)
		.map(
			(a: Asset) =>
				({
					id: a.AssetId,
					parentId: a.ParentAssetId,
					name: a.AssetName,
					isLeaf: a.IsLeaf,
					isActive: true,
					children: [],
				}) as AssetCode,
		);

	const assetTree = buildTreeAssets(rowsMapped || []);

	useEffect(() => {
		if (e && isError) {
			setError(e.message);
		}
	}, [e, isError]);

	if (isLoading || assetTree == null) {
		return (
			<TextField
				disabled
				label="Code"
				variant="outlined"
				fullWidth
				size="small"
				slotProps={{
					input: {
						endAdornment: <CircularProgress size={20} />,
					} as any,
				}}
			/>
		);
	} else {
		return (
			<>
				<FormControl error={!!fieldError} fullWidth>
					<TreePickerControlV2
						inputTitle={label}
						title={label}
						dataSource={assetTree}
						value={value || 0}
						onSelect={(value: number) => {
							onChange(value);
						}}
						allowSearch
						selectBranch
						selectActive={false}
						selectInternal={false}
						disabled={disabled}
					/>
					{fieldError && <FormHelperText>{fieldError.message}</FormHelperText>}
				</FormControl>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
};
